import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { NavLink } from "react-router-dom"; // Replace Link with NavLink
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/configureStore';
import LoginModal from './modals/LoginModal';
import userLoginAPIInstance from '../services/userLoginAPI'; // Import the UserLoginAPI instance
import { AppDispatch } from "../store/configureStore";
import { logoutUser } from '../actions/loginActions';
import logo from '../icons/logo.svg'; // Logo import
import profileIcon from '../icons/update_profile.svg'; // Profile icon import

const ROLE_RUNNER = 'ROLE_RUNNER';
const ROLE_TRAINER = 'ROLE_TRAINER';
const ROLE_ADMIN = 'ROLE_ADMIN';

interface MainMenuProps {
  onLogout: () => void;
  onLogin: () => void;
}

const MainMenu: React.FC<MainMenuProps> = ({ onLogout, onLogin }) => {
  const dispatch = useDispatch<AppDispatch>();
  const userStore = useSelector((state: RootState) => state.loggedInUser);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [roles, setRoles] = useState<string[]>([]);

  // Load roles from localStorage on component mount
  useEffect(() => {
    const storedRoles = localStorage.getItem('userRoles');
    if (storedRoles) {
      setRoles(JSON.parse(storedRoles)); // Parse roles and update state
    }
  }, [userStore]); // Re-run whenever userStore changes

  const handleCloseLogin = () => {
    setShowLoginModal(false);
  };

  const handleLoginSuccess = (loginData: any) => {
    setRoles(loginData.roles); // Update roles on successful login
    localStorage.setItem('userRoles', JSON.stringify(loginData.roles)); // Persist roles in localStorage
    setShowLoginModal(false); // Close modal
  };

  const handleLogout = async () => {
    try {
      const logoutSuccess = await userLoginAPIInstance.logout();
      if (logoutSuccess) {
        dispatch(logoutUser());
        setRoles([]); // Clear roles on logout
        localStorage.removeItem("authToken");
        localStorage.removeItem("currentUser");
        localStorage.removeItem("userRoles");
        onLogout(); // Notify App component
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const hasRole = (role: string): boolean => roles.includes(role);

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand as={NavLink} to="/">
            <img src={logo} alt="Logo" style={{ height: '40px', marginRight: '10px' }} />
            Raporty treningów
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {hasRole(ROLE_RUNNER) && (
                <>
                  <NavLink
                    to="/trainings"
                    className="nav-link"
                  >
                    Treningi
                  </NavLink>
                  <NavLink
                    to="/weekly-summary"
                    className="nav-link"
                  >
                    Podsumowanie tygodniowe
                  </NavLink>
                  <NavLink
                    to="/training-periods"
                    className="nav-link"
                  >
                    Okresy treningowe
                  </NavLink>
                </>
              )}
              {hasRole(ROLE_ADMIN) && (
                <NavDropdown title="Użytkownicy" id="users-dropdown">
                  <NavDropdown.Item as={NavLink} to="/users/add">Dodaj użytkownika</NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/userList">Lista użytkowników</NavDropdown.Item>
                </NavDropdown>
              )}
            </Nav>
            <Nav className="ml-auto">
              {userStore ? (
                <>
                  {/* User Dropdown Menu */}
                  <NavDropdown title={<img src={profileIcon} alt="Profil" style={{ height: '30px', filter: 'invert(1)' }} />} id="profile-dropdown">

                    {/* User Info */}
                    <NavDropdown.Item disabled className="text-dark fw-bold">
                      {userStore.email || 'Użytkownik'}
                    </NavDropdown.Item>

                    <NavDropdown.Divider />

                    {/* Profile Edit */}
                    <NavDropdown.Item as={NavLink} to="/user-profile">
                      Edytuj profil
                    </NavDropdown.Item>

                    {/* Runner Options 
                    {hasRole(ROLE_RUNNER) && (
                      <>
                        <NavDropdown.Item as={NavLink} to="/trainer/add">
                          Dodaj trenera
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="/trainer/list">
                          Lista trenerów
                        </NavDropdown.Item>
                      </>
                    )}*/}

                    {/* Trainer Options */}
                    {hasRole(ROLE_TRAINER) && (
                      <>
                        <NavDropdown.Item as={NavLink} to="/athlete/add">
                          Dodaj zawodnika
                        </NavDropdown.Item>
                        <NavDropdown.Item as={NavLink} to="/athlete/list">
                          Lista zawodników
                        </NavDropdown.Item>
                      </>
                    )}

                    <NavDropdown.Divider />

                    {/* Logout */}
                    <NavDropdown.Item onClick={handleLogout}>
                      Wyloguj
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                <Nav.Link onClick={onLogin} className="btn btn-outline-light">
                  Zaloguj
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <LoginModal
        show={showLoginModal}
        onClose={handleCloseLogin}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
};

export default MainMenu;
